import { WithSnackbarProps } from 'notistack';

export const NotificationHelper = {
    RequestPermission: () => {
        if (typeof window === 'undefined' || typeof window.Notification === 'undefined') {
            console.warn("Notification API not supported.");
            return;
        }

        try {
            Notification.requestPermission();
        } catch (e) {
            console.error("Error requesting notification permission:", e);
        }
    },

    Send: async (title: string, message: string, targetLink: string, mySnackbar: WithSnackbarProps) => {
        if (typeof window === 'undefined' || typeof window.Notification === 'undefined') {
            console.warn("Notification API not supported.");
            showToast(title, message, mySnackbar); // kendi toast fonksiyonunuz}
            return;
        }

        try {
            const permission = await Notification.requestPermission();
            if (permission !== "granted") {
                showToast(title, message, mySnackbar); // kendi toast fonksiyonunuz}
                return;
            }

            const notif = new Notification(title, { body: message });

            notif.onclick = () => {
                try {
                    window.open(targetLink, "_blank");
                } catch (e) {
                    console.error("Failed to open target link:", e);
                }
            };
        } catch (e) {
            console.error("Error showing notification:", e);
            showToast(title, message, mySnackbar); // kendi toast fonksiyonunuz}
        }
    }
};
function showToast(title: string, message: string, mySnackbar: WithSnackbarProps) {
    mySnackbar.enqueueSnackbar(`${title} - ${message}`, { })
}

